import React from "react";
import { currentTimeInTimezone, parseAsDate } from "../pages/utils/utils";
import { useState } from "react";
import { useEffect } from "react";

const Timer = ({ timeZone, timeStamp }) => {
  const calculateTimeLeft = () => {
    const currentTime = currentTimeInTimezone(new Date(), timeZone);
    const newTimeStampFormat = parseAsDate(timeStamp)?.$d;
    const expiryTime = currentTimeInTimezone(newTimeStampFormat, timeZone);
    const date1 = new Date(expiryTime);
    const date2 = new Date(currentTime);
    const milliseconds = date1 - date2;
    let timeLeft = {};
    if (milliseconds > 0) {
      const hours = Math.floor(milliseconds / 36e5);
      const minutes = Math.floor((milliseconds % 36e5) / 6e4);
      const seconds = Math.floor((milliseconds % 6e4) / 1e3);
      timeLeft = {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      };
    }

    return timeLeft;
  };
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
  });

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {" "}
      {timeLeft.hours || timeLeft.minutes || timeLeft.seconds ? (
        <div>
          <span>
            {timeLeft.hours >= 0 && timeLeft.hours <= 9
              ? "0" + timeLeft.hours
              : timeLeft.hours}
          </span>
          <span>:</span>
          <span>
            {timeLeft.minutes >= 0 && timeLeft.minutes <= 9
              ? "0" + timeLeft.minutes
              : timeLeft.minutes}
          </span>
          <span>:</span>
          <span>
            {timeLeft.seconds >= 0 && timeLeft.seconds <= 9
              ? "0" + timeLeft.seconds
              : timeLeft.seconds}
          </span>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default Timer;
